module.exports = __webpack_public_path__ + "static/img/02.5b2fc298.png";